import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import EffectType from "@/effects/EffectType"
import { Personality } from "@/employee/Personality"

export class GreedyPersonality extends Personality {
    id: string = 'greedy'
    affix: string = 'prefix'

    description(): string {
      return `Greedy characters value high salaries and gifts, to the point of arousal.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "salaryMood": [new ValueMod(1.5, 'mul')],
        "giftMood": [new ValueMod(1.5, 'mul')]
      }
    }

    onGift(employee: Employee) {
      employee.lust.addValue(5)

      employee.effectManager.addTempEffect(
        'greedy-gift',
        'lust',
        new ValueMod(10, 'add'),
        new EffectType(30, 'instant', 'temporary')
      )
    }
}
